import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Button } from 'foundations-components/transitional/components/Button';
import { CompletionStatuses } from '../../constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RecommendationBaseView = ({
  testId,
  title,
  description,
  status,
  action,
  actionButtonText,
  onTrackAction,
  children
}) => {
  const hideRecommendation = status === CompletionStatuses.NOT_APPLICABLE;
  const backgroundColor = status === CompletionStatuses.COMPLETE ? 'fill-positive-default' : 'fill-tertiary-pressed';
  const showActionLink = action && status === CompletionStatuses.INCOMPLETE;
  if (hideRecommendation) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": testId || 'recommendation-base-view',
    marginInline: "100",
    as: "div",
    children: [/*#__PURE__*/_jsxs(TFlex, {
      align: "baseline",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(IconCircle, {
          color: "fill-surface-default",
          backgroundColor: backgroundColor,
          icon: SuccessIcon,
          size: "100",
          padding: "25"
        })
      }), /*#__PURE__*/_jsx(H7, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(View, {
          marginInlineStart: "200",
          marginBlockStart: "100",
          as: "div",
          children: title
        })
      })]
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "200",
      marginInlineStart: "600",
      as: "div",
      children: [/*#__PURE__*/_jsx("div", {
        children: description
      }), showActionLink && /*#__PURE__*/_jsx(View, {
        marginBlock: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => {
            if (onTrackAction) {
              onTrackAction();
            }
            action();
          },
          size: "small",
          use: "tertiary",
          children: actionButtonText || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.actions.fix"
          })
        })
      })]
    }), children]
  });
};